/**
 * A saved SDTM comparison from before version 6 kept at most 100 items and no
 * count beside them. One sitting exactly at that cap may be missing items, so
 * the screen must not read it as complete. Mirrors s3RecordMayBeIncomplete in
 * functions/src/verification/pipelineChecks.ts (keep the two in step).
 */
export const S3_CAP = 100;
export const S3_COUNTS_FROM_VERSION = 6;

export const S3_OLD_RECORD_NOTE =
  'The saved comparison of the data dictionary with the SDTM mapping is from an older version and may be missing items. Re-run Verification to see the full result.';

export function s3RecordNote(
  checksVersion: number | null | undefined,
  itemCount: number,
): string | null {
  const v = typeof checksVersion === 'number' ? checksVersion : 0;
  return v < S3_COUNTS_FROM_VERSION && itemCount >= S3_CAP ? S3_OLD_RECORD_NOTE : null;
}

/**
 * The SDTM mapping's not-submitted SUGGESTIONS (S3 kind
 * "not-submitted-proposal"): a proposal by the mapping model, not a decision.
 * Since 2026-10-25 (Jim) they do not hold the data dictionary download, so
 * this note is where the page still says they exist. Counted from the record's
 * full per-kind counts; the item list is capped at 100.
 */
export function s3ProposalNote(
  counts: Record<string, number> | undefined,
  items: Array<{ kind?: string }> | undefined,
): string | null {
  const fromCounts = counts?.['not-submitted-proposal'];
  const n = typeof fromCounts === 'number' ? fromCounts : (items ?? []).filter((i) => i.kind === 'not-submitted-proposal').length;
  if (n <= 0) return null;
  const fields = n === 1 ? '1 field' : `${n} fields`;
  return (
    `The SDTM mapping suggests ${fields} not be submitted. A suggestion is not a decision and does not hold ` +
    `the data dictionary download. Review ${n === 1 ? 'it' : 'them'} on the SDTM Mapping page, where ${n === 1 ? 'it is' : 'they are'} marked ` +
    `"Not submitted only on the mapping model's proposal".`
  );
}
